import _ from '../no_conflict_lodash';
import { TASK_TYPES } from './constants';

export function getTaskTypeLabel(taskType) {
  const type = TASK_TYPES[_.camelCase(taskType)];
  return type ? type.label : _.capitalize(taskType);
}
